import { money } from "./settlementApi";

const COLS = [
  ["item", "Item"], ["final_rent", "Final rent"], ["extra_charges_total", "Extra charges"], ["original_bond", "Bond"],
  ["bond_deducted", "Bond used"], ["bond_refunded", "Bond refunded"], ["rental_credit_issued", "Credit"], ["outstanding", "Outstanding"],
];

export function GroupSettlementTable({ group }) {
  if (!group?.items?.length || group.items.length < 2) return null;
  return (
    <div className="border border-[#282828]/8 bg-white overflow-x-auto" data-testid="group-settlement-table">
      <div className="px-4 py-2 text-[10px] uppercase tracking-[0.14em] text-[#9A7B4F] border-b border-[#282828]/8">Whole booking group</div>
      <table className="w-full text-[11px]">
        <thead className="bg-[#FAF8F0] text-[#676664]/70">
          <tr>{COLS.map(([k, l]) => <th key={k} className={`px-3 py-2 font-medium ${k === "item" ? "text-left" : "text-right"}`}>{l}</th>)}</tr>
        </thead>
        <tbody>
          {group.items.map((it) => (
            <tr key={it.booking_id} className="border-t border-[#282828]/5" data-testid={`group-row-${it.booking_id}`}>
              {COLS.map(([k]) => (
                <td key={k} className={`px-3 py-2 ${k === "item" ? "text-left text-[#282828]" : "text-right tabular-nums"}`}>
                  {k === "item" ? <>{it.item}<div className="text-[9px] text-[#676664]/50 uppercase">{(it.settlement_status || "").replace(/_/g, " ")}</div></> : money(it[k])}
                </td>
              ))}
            </tr>
          ))}
          <tr className="border-t-2 border-[#282828]/15 font-semibold bg-[#FAF8F0]" data-testid="group-totals-row">
            {COLS.map(([k]) => <td key={k} className={`px-3 py-2 ${k === "item" ? "text-left" : "text-right tabular-nums"}`}>{k === "item" ? "Total" : money(group.totals[k])}</td>)}
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export function SettlementTimeline({ events }) {
  if (!events?.length) return <div className="text-[12px] text-[#676664]/50" data-testid="settlement-timeline-empty">No financial history yet.</div>;
  return (
    <ol className="relative border-l border-[#9A7B4F]/25 ml-2 space-y-3" data-testid="settlement-timeline">
      {events.map((e, i) => (
        <li key={i} className="ml-4" data-testid={`settlement-event-${i}`}>
          <span className={`absolute -left-[5px] mt-1.5 w-2.5 h-2.5 rounded-full ${e.kind?.includes("failed") || e.kind?.includes("abandoned") ? "bg-red-400" : "bg-[#9A7B4F]"}`} />
          <div className="text-[12px] text-[#282828]">{e.label}</div>
          <div className="text-[10px] text-[#676664]/55">
            {e.at ? new Date(e.at).toLocaleString("en-AU") : ""}{e.by ? ` · ${e.by}` : ""}{e.reason ? ` · ${e.reason}` : ""}{e.status ? ` · ${String(e.status).replace(/_/g, " ")}` : ""}
          </div>
        </li>
      ))}
    </ol>
  );
}
